import React, {Component} from 'react';
import './input.css';
import logoba from '../../assets/img/logo-ba.png';
import '../../assets/scss/buttons.css';

function importAll(r) {
    let images = {};
    r.keys().map((item, index) => images[item.replace('./', '')] = r(item));
    return images;
}

const images = importAll(require.context('../../assets/img/flags', false, /\.(svg)$/));

class Input extends Component {
    constructor(props) {
        super(props);
        this.data = this.props.group.matches;
    }
    handleChange = (value, team, index, teamIndex) => {
        this.data[index][teamIndex].score = value;
    };

    render() {
        return (
            <div className="submit-score">
                <div className="submit-header">
                    <div className="wrapper">
                        <img src={logoba} width="42" alt="world cup" />
                        <div className="info">
                            <span>{this.props.group.name}</span>
                            <h4>Matches</h4>
                            <b>Please fill in the score for each match</b>
                        </div>
                        <div className="cta">
                            <button className="btn btn-grey" onClick={this.props.closeInput}>Close</button>
                            { (this.props.index < 8)? <button className="btn btn-grey" onClick={this.props.nextGroup}>Next Group</button>: ''}
                            <button className="btn btn-green" onClick={() => { this.props.saveResults(this.data)}}>Save</button>
                        </div>
                    </div>
                </div>

                <ul className="submit-body">
                    {this.props.group.matches.map((match, index) => (
                        <li key={match.id}>
                            <div className="team">
                                <figure><img src={images[`${match.team1.abr}.svg`]} alt="" /></figure>
                                <div>
                                    <span>{match.team1.name}</span>
                                    <input type="tel"
                                           maxlength="2"
                                           min="0"
                                           max="20"
                                           pattern="\d*"
                                           onChange={e => { this.handleChange(e.target.value, match.team1, index, 'team1'); }}
                                           name="match.team1.name.toLowerCase().replace(' ', '_')"
                                           placeholder={match.team1.score? '': 'Input score'}/>
                                    <b>{match.team1.score}</b>
                                </div>
                            </div>
                            <div className="match_info">
                                <span>{match.info.when}</span>
                                <span>{match.info.stadium}</span>
                                <span>{match.info.city}</span>
                            </div>
                            <div className="team">
                                <figure><img src={images[`${match.team2.abr}.svg`]} alt="" /></figure>
                                <div>
                                    <span>{match.team2.name}</span>
                                    <input type="tel"
                                           maxlength="2"
                                           min="0"
                                           max="20"
                                           pattern="\d*"
                                           onChange={e => { this.handleChange(e.target.value, match.team2, index, 'team2'); }}
                                           name="match.team2.name.toLowerCase().replace(' ', '_')"
                                           placeholder={match.team2.score? '': 'Input score'}/>
                                    <b>{match.team2.score}</b>
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default Input;


// WEBPACK FOOTER //
// ./src/components/Input/Input.jsx